import React, { useEffect } from "react";
import ReactGA from "react-ga4";
import pdf from "../assets/SOUMYAJIT_PAN_Resume.pdf";
import "../styles/resume.css";
import PdfViewer from "./PdfViewer";
import { Button } from "./CustomElements";

const Resume = () => {
  useEffect(() => {
    // Google Analytics
    ReactGA.send({ hitType: "pageview", page: "/resume", title: "Resume" });
  }, []);

  const handleViewFullPageClick = () => {
    ReactGA.event({
      category: "Button.Click",
      action: "Full Screen Resume",
    });
    window.open(pdf); // Open in the same tab
  };

  const handleDownloadClick = () => {
    ReactGA.event({
      category: "Button.Click",
      action: "Download Resume",
    });

    // Create a hidden link element
    const link = document.createElement("a");
    link.href = pdf;
    link.download = "SOUMYAJIT_PAN_Resume.pdf";
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  return (
    <div className="resume_container">
      <div className="resume_button_container">
        <Button className="button" onClick={handleViewFullPageClick}>
          View Full Page
        </Button>
        <Button className="button" onClick={handleDownloadClick}>
          Download
        </Button>
      </div>
      <PdfViewer pdf={pdf} />
    </div>
  );
};

export default Resume;
